import React, {
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { useSetStuffToRenderOnNavbar } from "../../contexts/NavbarCommonSpace";
import { TApplication } from "../../hooks/applications.hooks";

const ApplicationFormContext = createContext<
  [TApplication | null, React.Dispatch<SetStateAction<TApplication | null>>]
>([null, () => null]);

export function ApplicationFormContextProvider({
  children,
  defaultValue,
}: {
  children: ReactNode | ReactNode[];
  defaultValue?: null | TApplication;
}) {
  const value = useState<null | TApplication>(defaultValue || null);
  const application = value[0];
  const setStuff = useSetStuffToRenderOnNavbar();

  useEffect(() => {
    setStuff(
      <div className="md:ml-auto md:mr-8">
        <p className="text-grey-600">
          <span className="w-28 font-semibold inline-block">
            Application ID
          </span>
          <span>{`: ${application?.applicationId || "Nil"}`}</span>
        </p>
        <p className="text-grey-600">
          <span className="w-28 font-semibold inline-block">Status</span>
          <span>{`: ${application?.status || "Nil"}`}</span>
        </p>
      </div>
    );
    return () => setStuff(null);
  }, [setStuff, application]);

  return (
    <ApplicationFormContext.Provider value={value}>
      {children}
    </ApplicationFormContext.Provider>
  );
}

export function useSelectedApplication() {
  return useContext(ApplicationFormContext)[0];
}

export function useSetSelectedApplication() {
  return useContext(ApplicationFormContext)[1];
}
